import {Action, action} from 'easy-peasy';

export interface ActiveStoryObjectModel {
    activeStoryObject: string;
    setActiveStoryObject: Action<ActiveStoryObjectModel, string>;
}

export default <ActiveStoryObjectModel>{
    activeStoryObject: '',
    setActiveStoryObject: action((state, storyObject) => {
        state.activeStoryObject = storyObject;
    }),
};
